import type { FunctionComponent } from 'react';
import { getSlotDefaultParams } from '@media-platform/slot/src/core/utils/getSlotDefaultParams';
import { AgoProvider } from '@media-ui/ago';
import 'Tools/xray';
import { initDWHLogger } from 'Tools/dwhLogger';
import { useAppContext } from 'Containers/App/App.context';
import Footer from 'Components/Footer';
import { PortalMenu } from 'Containers/Header';
import Slot from 'Containers/Slot';
import Pages from 'Containers/Pages';
import { PAGE_TYPES } from 'Src/constants';
import { getSlot } from 'Src/utils/slots';
import { SlotSSI } from '@media-platform/slot/src/react';
import classNames from 'classnames';
import * as s from './Layout.css';
import type { IArticlePageData } from 'Src/pages/ArticlePage/ArticlePage.types';
void initDWHLogger();
const Layout: FunctionComponent = () => {
    const { layout, page_type, page_data } = useAppContext();
    const { custom: { isMobile }, rb, } = layout;
    const slotParams = {
        _SITEID: rb.site_id,
        ...getSlotDefaultParams(rb),
    };
    const { article } = page_data as IArticlePageData;
    const renderBrandingSlot = () => {
        return (<>
        <SlotSSI slot={getSlot('brandingTopSSI', isMobile, slotParams, page_type)}/>
        <Slot className="rb-slot_plug-x90" alias="brandingTopAdp" isPageSpecificSlot/>
      </>);
    };
    const isAddPetPage = page_type === PAGE_TYPES.addPet;
    const isErrorPage = page_type === PAGE_TYPES.error;
    return (<>
      <div data-logger-parent="top">{isMobile && renderBrandingSlot()}</div>
      <div className={classNames('rb-p-branding--body', {
            'add-pet-page': isAddPetPage,
        })}>
        <PortalMenu layout={layout} isFixed={Boolean(!article?.navigation || rb.entity_type === 'card') &&
            !isAddPetPage} className={classNames({ [s.addPetHeader]: isAddPetPage })} showMobilePromo={page_type !== 'add_pet'}/>
        {!isMobile && renderBrandingSlot()}
        <div className="rb-p-branding--content rb-p-branding--wrapper">
          <div data-logger-parent="content">
            <AgoProvider>
              <Pages />
            </AgoProvider>
          </div>
          {!isAddPetPage ? (<div data-logger-parent="footer">
              {!isErrorPage && (<Slot alias="registrationBanner" isPageSpecificSlot/>)}
              <Slot alias="brandingFooter"/>
              <Footer />
              <Slot alias="npsPoll"/>
              <Slot alias="recommendationSplash"/>
            </div>) : null}
        </div>
      </div>
    </>);
};
export default Layout;
